import React from 'react';
import { Meteor } from 'meteor/meteor';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Styles from './styles';

const {
  twitterUsername,
  facebookUsername,
  linkedinUsername,
  instagramUsername
} = Meteor.settings.public;

const SocialMediaIcons = () => (
  <Styles.SocialMediaIcons>
    <li>
      <a
        href={`https://www.facebook.com/${facebookUsername}`}
        target="_blank"
        rel="noreferrer noopener"
      >
        <FontAwesomeIcon icon={['fab', 'facebook']} />
      </a>
    </li>
    <li>
      <a href={`https://twitter.com/${twitterUsername}`} target="_blank" rel="noreferrer noopener">
        <FontAwesomeIcon icon={['fab', 'twitter']} />
      </a>
    </li>
    <li>
      <a
        href={`https://www.linkedin.com/company/${linkedinUsername}`}
        target="_blank"
        rel="noreferrer noopener"
      >
        <FontAwesomeIcon icon={['fab', 'linkedin']} />
      </a>
    </li>
    <li>
      <a
        href={`https://www.instagram.com/${instagramUsername}`}
        target="_blank"
        rel="noreferrer noopener"
      >
        <FontAwesomeIcon icon={['fab', 'instagram']} />
      </a>
    </li>
  </Styles.SocialMediaIcons>
);

export default SocialMediaIcons;
